import { availableNetworks } from '@polkadot/networks';
export const PREFIX_DEFAULT = -1;
const defaultNetwork = {
    info: 'default',
    text: 'Default for the connected node',
    value: -1
};
const networks = availableNetworks.map(({ displayName, network, prefix }) => ({
    info: network,
    text: displayName,
    value: prefix
}));
export const PREFIXES = [defaultNetwork, ...networks];
